// src/pages/pengamatan/buah-alami/detail-tabs/PopulasiPerHaTab.jsx
import React from 'react';
import {
    Box,
    Card,
    CardContent,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableRow,
    Paper
} from '@mui/material';
import PopulasiPerHaTableHeader from './PopulasiPerHaTableHeader';

const PopulasiPerHaTab = ({ pengamatanData, filteredPlots }) => {
    // FUNGSI BARU: Format khusus untuk total (2 digit di belakang koma)
    const formatAngkaTotal = (angka) => {
        if (!angka || angka === '-' || isNaN(parseFloat(angka))) return '-';
        
        const num = parseFloat(angka);
        
        if (Math.abs(num) < 0.0001) {
            return '-';
        }
        
        // Format dengan 2 digit di belakang koma
        const formatted = num.toFixed(2);
        const parts = formatted.split('.');
        const integerPart = parts[0];
        const decimalPart = parts[1] || '';
        
        const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        
        return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
    };

    // FUNGSI BARU: Format khusus untuk PJP (tanpa desimal)
    const formatPJP = (angka) => {
        if (!angka || angka === '-' || isNaN(parseFloat(angka))) return '-';
        
        const num = parseFloat(angka);
        
        // Format tanpa desimal, langsung bulatkan
        const rounded = Math.round(num);
        return rounded.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    };

    // Fungsi untuk menghitung prosentase fase bunga (sama seperti di ProsentaseTab)
    const calculateFaseBungaPercentage = (plotData, fieldName) => {
        const faseBunga = plotData.data_entry?.fase_bunga || {};
        const total = parseFloat(plotData.data_entry?.total_ba) || 0;
        const fieldValue = parseFloat(faseBunga[fieldName]) || 0;
        
        if (total > 0) {
            return (fieldValue / total) * 100; // Return number tanpa '%'
        }
        return 0;
    };

    // Fungsi untuk menghitung prosentase tanaman (sama seperti di ProsentaseTab)
    const calculateTanamanPercentage = (plotData, fieldName) => {
        const tanaman = plotData.data_entry?.tanaman || {};
        const penyakit = plotData.data_entry?.tanaman?.penyakit_tanaman || {};
        const total = parseFloat(plotData.data_entry?.total_ba) || 0;
        
        let fieldValue = 0;
        
        // Cek apakah field ada di tanaman utama atau di penyakit
        if (fieldName.includes('penyakit_')) {
            const penyakitField = fieldName.replace('penyakit_', '');
            fieldValue = parseFloat(penyakit[`${penyakitField}_pt_ba`]) || 0;
        } else {
            fieldValue = parseFloat(tanaman[`${fieldName}_t_ba`]) || 0;
        }
        
        if (total > 0) {
            return (fieldValue / total) * 100; // Return number tanpa '%'
        }
        return 0;
    };

    // FUNGSI BARU: Menghitung prosentase buah alami dan mati
    const calculateBuahAlamiMatiPercentage = (plotData, fieldName) => {
        const dataEntry = plotData.data_entry || {};
        const total = parseFloat(dataEntry.total_ba) || 0;
        
        let fieldValue = 0;
        
        if (fieldName === 'buah_alami_ba') {
            fieldValue = parseFloat(dataEntry.buah_alami_ba) || 0;
        } else if (fieldName === 'mati_ba') {
            fieldValue = parseFloat(dataEntry.mati_ba) || 0;
        }
        
        if (total > 0) {
            return (fieldValue / total) * 100; // Return number tanpa '%'
        }
        return 0;
    };

    // FUNGSI YANG DIPERBAIKI: Format angka dengan aturan baru
    const formatAngkaExcel = (angka) => {
        if (!angka || angka === '-' || isNaN(parseFloat(angka))) return '-';
        
        const num = parseFloat(angka);
        
        // Jika hasilnya 0.000 atau -0.000, tampilkan "-"
        if (Math.abs(num) < 0.0001) {
            return '-';
        }
        
        // Jika angka >= 1, tampilkan 3 angka di belakang koma
        if (num >= 1) {
            // Format dengan 3 desimal
            const formatted = num.toFixed(3);
            
            // Pisahkan bagian integer dan desimal
            const parts = formatted.split('.');
            const integerPart = parts[0];
            const decimalPart = parts[1] || '';
            
            // Format bagian integer dengan pemisah ribuan (titik)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            
            // Gabungkan kembali dengan desimal menggunakan titik
            return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
        } 
        // Jika angka < 1, tampilkan hanya bagian desimal (tanpa "0.")
        else {
            const decimalPart = num.toFixed(3).split('.')[1];
            
            // Jika bagian desimal adalah "000", tampilkan "-"
            if (decimalPart === '000') {
                return '-';
            }
            
            return decimalPart;
        }
    };

    // FUNGSI BARU: Format khusus untuk baris total (tanpa leading zeros)
    const formatAngkaTotalPopulasi = (angka) => {
        if (!angka || angka === '-' || isNaN(parseFloat(angka))) return '-';
        
        const num = parseFloat(angka);
        
        // Jika hasilnya 0.000 atau -0.000, tampilkan "-"
        if (Math.abs(num) < 0.0001) {
            return '-';
        }
        
        // Jika angka >= 1, tampilkan 3 angka di belakang koma
        if (num >= 1) {
            // Format dengan 3 desimal
            const formatted = num.toFixed(3);
            
            // Pisahkan bagian integer dan desimal
            const parts = formatted.split('.');
            const integerPart = parts[0];
            const decimalPart = parts[1] || '';
            
            // Format bagian integer dengan pemisah ribuan (titik)
            const formattedInteger = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
            
            // Gabungkan kembali dengan desimal menggunakan titik
            return decimalPart ? `${formattedInteger}.${decimalPart}` : formattedInteger;
        } 
        // Jika angka < 1, tampilkan hanya bagian desimal (tanpa "0.") dan HAPUS LEADING ZEROS
        else {
            const decimalPart = num.toFixed(3).split('.')[1];
            
            // Jika bagian desimal adalah "000", tampilkan "-"
            if (decimalPart === '000') {
                return '-';
            }
            
            // HAPUS SEMUA LEADING ZEROS
            return decimalPart.replace(/^0+/, '');
        }
    };

    // FUNGSI BARU: Menghitung total dari semua plot dengan formula yang sama
    const calculateTotalRow = (plotsData) => {
        if (plotsData.length === 0) return null;

        // Kumpulkan data total dari semua plot
        let totalBA = 0;
        let totalPJP = 0;
        let totalLuasPlot = 0;

        // Data untuk menghitung presentase total
        let totalFaseBunga = {
            open_heart_fb_ba: 0,
            red_bud_125_fb_ba: 0,
            red_bud_254_fb_ba: 0,
            early_cones_fb_ba: 0,
            mid_cones_fb_ba: 0,
            late_cones_fb_ba: 0,
            early_petals_fb_ba: 0,
            mid_petals_fb_ba: 0,
            late_petals_fb_ba: 0,
            dry_petals_fb_ba: 0,
            filling_stage_1_fb_ba: 0,
            filling_stage_2_fb_ba: 0,
            sc0_fb_ba: 0,
            sc0_ld_fb_ba: 0,
            terpetik_fb_ba: 0,
            dimakan_tikus_fb_ba: 0
        };

        let totalTanaman = {
            normal_t_ba: 0,
            kerdil_t_ba: 0
        };

        let totalPenyakit = {
            phy_pt_ba: 0,
            erw_pt_ba: 0
        };

        let totalBuahAlami = 0;
        let totalMati = 0;
        let overallTotalBA = 0;

        // Kumpulkan data dari semua plot
        plotsData.forEach(plot => {
            const dataEntry = plot.data_entry || {};
            const faseBunga = dataEntry.fase_bunga || {};
            const tanaman = dataEntry.tanaman || {};
            const penyakit = dataEntry.tanaman?.penyakit_tanaman || {};
            
            const plotTotalBA = parseFloat(dataEntry.total_ba) || 0;
            const plotPJP = parseFloat(plot.pjp) || 0;
            const plotLuasPlot = parseFloat(plot.luas_plot) || 0;

            totalBA += plotTotalBA;
            totalPJP += plotPJP;
            totalLuasPlot += plotLuasPlot;
            overallTotalBA += plotTotalBA;

            // Kumpulkan data fase bunga
            Object.keys(totalFaseBunga).forEach(key => {
                totalFaseBunga[key] += parseFloat(faseBunga[key]) || 0;
            });

            // Kumpulkan data tanaman
            totalTanaman.normal_t_ba += parseFloat(tanaman.normal_t_ba) || 0;
            totalTanaman.kerdil_t_ba += parseFloat(tanaman.kerdil_t_ba) || 0;

            // Kumpulkan data penyakit
            totalPenyakit.phy_pt_ba += parseFloat(penyakit.phy_pt_ba) || 0;
            totalPenyakit.erw_pt_ba += parseFloat(penyakit.erw_pt_ba) || 0;

            // Kumpulkan data buah alami dan mati
            totalBuahAlami += parseFloat(dataEntry.buah_alami_ba) || 0;
            totalMati += parseFloat(dataEntry.mati_ba) || 0;
        });

        // Hitung presentase total untuk setiap kategori
        const calculateTotalPercentage = (fieldValue) => {
            if (overallTotalBA > 0) {
                return (fieldValue / overallTotalBA) * 100;
            }
            return 0;
        };

        // Hitung nilai dengan formula yang sama: (total_ba / pjp * 16666.67 * presentase) / 1000
        const calculateTotalValue = (percentage) => {
            if (totalPJP > 0) {
                const result = (totalBA / totalPJP) * 16666.67 * (percentage / 100);
                return (result / 1000).toFixed(3);
            }
            return '0.000';
        };

        // Hitung presentase total untuk setiap fase bunga
        const openHeartPercentage = calculateTotalPercentage(totalFaseBunga.open_heart_fb_ba);
        const redBud125Percentage = calculateTotalPercentage(totalFaseBunga.red_bud_125_fb_ba);
        const redBud254Percentage = calculateTotalPercentage(totalFaseBunga.red_bud_254_fb_ba);
        const earlyConesPercentage = calculateTotalPercentage(totalFaseBunga.early_cones_fb_ba);
        const midConesPercentage = calculateTotalPercentage(totalFaseBunga.mid_cones_fb_ba);
        const lateConesPercentage = calculateTotalPercentage(totalFaseBunga.late_cones_fb_ba);
        const earlyPetalsPercentage = calculateTotalPercentage(totalFaseBunga.early_petals_fb_ba);
        const midPetalsPercentage = calculateTotalPercentage(totalFaseBunga.mid_petals_fb_ba);
        const latePetalsPercentage = calculateTotalPercentage(totalFaseBunga.late_petals_fb_ba);
        const dryPetalsPercentage = calculateTotalPercentage(totalFaseBunga.dry_petals_fb_ba);
        const fillingStage1Percentage = calculateTotalPercentage(totalFaseBunga.filling_stage_1_fb_ba);
        const fillingStage2Percentage = calculateTotalPercentage(totalFaseBunga.filling_stage_2_fb_ba);
        const sc0Percentage = calculateTotalPercentage(totalFaseBunga.sc0_fb_ba);
        const sc0LebihPercentage = calculateTotalPercentage(totalFaseBunga.sc0_ld_fb_ba);
        const terpetikPercentage = calculateTotalPercentage(totalFaseBunga.terpetik_fb_ba);
        const dimakanTikusPercentage = calculateTotalPercentage(totalFaseBunga.dimakan_tikus_fb_ba);

        // Hitung presentase total untuk tanaman
        const normalTanamanPercentage = calculateTotalPercentage(totalTanaman.normal_t_ba);
        const penyakitPhyPercentage = calculateTotalPercentage(totalPenyakit.phy_pt_ba);
        const penyakitErwPercentage = calculateTotalPercentage(totalPenyakit.erw_pt_ba);
        const kerdilPercentage = calculateTotalPercentage(totalTanaman.kerdil_t_ba);

        // Hitung presentase total untuk buah alami dan mati
        const buahAlamiPercentage = calculateTotalPercentage(totalBuahAlami);
        const matiPercentage = calculateTotalPercentage(totalMati);

        // Hitung nilai total dengan formula yang sama
        return {
            plot: 'Total',
            luasPlot: formatAngkaTotal(totalLuasPlot), // GUNAKAN formatAngkaTotal untuk luas
            pjp: formatPJP(totalPJP), // GUNAKAN formatPJP untuk PJP
            
            // Data fase bunga - GUNAKAN formatAngkaTotalPopulasi untuk menghapus leading zeros
            openHeart: formatAngkaTotalPopulasi(calculateTotalValue(openHeartPercentage)),
            redBud125: formatAngkaTotalPopulasi(calculateTotalValue(redBud125Percentage)),
            redBud254: formatAngkaTotalPopulasi(calculateTotalValue(redBud254Percentage)),
            earlyCones: formatAngkaTotalPopulasi(calculateTotalValue(earlyConesPercentage)),
            midCones: formatAngkaTotalPopulasi(calculateTotalValue(midConesPercentage)),
            lateCones: formatAngkaTotalPopulasi(calculateTotalValue(lateConesPercentage)),
            earlyPetals: formatAngkaTotalPopulasi(calculateTotalValue(earlyPetalsPercentage)),
            midPetals: formatAngkaTotalPopulasi(calculateTotalValue(midPetalsPercentage)),
            latePetals: formatAngkaTotalPopulasi(calculateTotalValue(latePetalsPercentage)),
            dryPetals: formatAngkaTotalPopulasi(calculateTotalValue(dryPetalsPercentage)),
            fillingStage1: formatAngkaTotalPopulasi(calculateTotalValue(fillingStage1Percentage)),
            fillingStage2: formatAngkaTotalPopulasi(calculateTotalValue(fillingStage2Percentage)),
            sc0: formatAngkaTotalPopulasi(calculateTotalValue(sc0Percentage)),
            sc0Lebih: formatAngkaTotalPopulasi(calculateTotalValue(sc0LebihPercentage)),
            terpetik: formatAngkaTotalPopulasi(calculateTotalValue(terpetikPercentage)),
            dimakanTikus: formatAngkaTotalPopulasi(calculateTotalValue(dimakanTikusPercentage)),
            
            // Data tanaman - GUNAKAN formatAngkaTotalPopulasi untuk menghapus leading zeros
            normalTanaman: formatAngkaTotalPopulasi(calculateTotalValue(normalTanamanPercentage)),
            penyakitPhy: formatAngkaTotalPopulasi(calculateTotalValue(penyakitPhyPercentage)),
            penyakitErw: formatAngkaTotalPopulasi(calculateTotalValue(penyakitErwPercentage)),
            kerdil: formatAngkaTotalPopulasi(calculateTotalValue(kerdilPercentage)),
            
            // Data buah alami dan mati - GUNAKAN formatAngkaTotalPopulasi untuk menghapus leading zeros
            buahAlami: formatAngkaTotalPopulasi(calculateTotalValue(buahAlamiPercentage)),
            mati: formatAngkaTotalPopulasi(calculateTotalValue(matiPercentage))
        };
    };

    const calculatePopulationPerHa = () => {
        // GUNAKAN filteredPlots JIKA ADA, JIKA TIDAK GUNAKAN SEMUA PLOT
        const plotsToUse = filteredPlots && filteredPlots.length > 0 
            ? filteredPlots 
            : (pengamatanData.plot ? Object.entries(pengamatanData.plot).map(([plotKey, plotData]) => ({
                plotKey,
                ...plotData
            })) : []);
        
        return plotsToUse
            .map((plot) => {
                const dataEntry = plot.data_entry || {};
                
                const totalBA = parseFloat(dataEntry.total_ba) || 0;
                const pjp = parseFloat(plot.pjp) || 1;
                const luasPlot = parseFloat(plot.luas_plot) || 1;
                
                // Formula: (total_ba / pjp * 16666.67 * presentase) / 1000
                const calculateValue = (percentage) => {
                    const result = (totalBA / pjp) * 16666.67 * (percentage / 100);
                    return (result / 1000).toFixed(3); // Dibagi 1000 dan 3 desimal
                };

                // Ambil presentase dari setiap fase bunga (sama seperti di tab Prosentase)
                const openHeartPercentage = calculateFaseBungaPercentage(plot, 'open_heart_fb_ba');
                const redBud125Percentage = calculateFaseBungaPercentage(plot, 'red_bud_125_fb_ba');
                const redBud254Percentage = calculateFaseBungaPercentage(plot, 'red_bud_254_fb_ba');
                const earlyConesPercentage = calculateFaseBungaPercentage(plot, 'early_cones_fb_ba');
                const midConesPercentage = calculateFaseBungaPercentage(plot, 'mid_cones_fb_ba');
                const lateConesPercentage = calculateFaseBungaPercentage(plot, 'late_cones_fb_ba');
                const earlyPetalsPercentage = calculateFaseBungaPercentage(plot, 'early_petals_fb_ba');
                const midPetalsPercentage = calculateFaseBungaPercentage(plot, 'mid_petals_fb_ba');
                const latePetalsPercentage = calculateFaseBungaPercentage(plot, 'late_petals_fb_ba');
                const dryPetalsPercentage = calculateFaseBungaPercentage(plot, 'dry_petals_fb_ba');
                const fillingStage1Percentage = calculateFaseBungaPercentage(plot, 'filling_stage_1_fb_ba');
                const fillingStage2Percentage = calculateFaseBungaPercentage(plot, 'filling_stage_2_fb_ba');
                const sc0Percentage = calculateFaseBungaPercentage(plot, 'sc0_fb_ba');
                const sc0LebihPercentage = calculateFaseBungaPercentage(plot, 'sc0_ld_fb_ba');
                const terpetikPercentage = calculateFaseBungaPercentage(plot, 'terpetik_fb_ba');
                const dimakanTikusPercentage = calculateFaseBungaPercentage(plot, 'dimakan_tikus_fb_ba');

                // Ambil presentase dari tanaman
                const normalTanamanPercentage = calculateTanamanPercentage(plot, 'normal');
                const penyakitPhyPercentage = calculateTanamanPercentage(plot, 'penyakit_phy');
                const penyakitErwPercentage = calculateTanamanPercentage(plot, 'penyakit_erw');
                const kerdilPercentage = calculateTanamanPercentage(plot, 'kerdil');

                // Ambil presentase untuk buah alami dan mati
                const buahAlamiPercentage = calculateBuahAlamiMatiPercentage(plot, 'buah_alami_ba');
                const matiPercentage = calculateBuahAlamiMatiPercentage(plot, 'mati_ba');

                // Hitung nilai dengan formula yang sudah disesuaikan
                const openHeart = calculateValue(openHeartPercentage);
                const redBud125 = calculateValue(redBud125Percentage);
                const redBud254 = calculateValue(redBud254Percentage);
                const earlyCones = calculateValue(earlyConesPercentage);
                const midCones = calculateValue(midConesPercentage);
                const lateCones = calculateValue(lateConesPercentage);
                const earlyPetals = calculateValue(earlyPetalsPercentage);
                const midPetals = calculateValue(midPetalsPercentage);
                const latePetals = calculateValue(latePetalsPercentage);
                const dryPetals = calculateValue(dryPetalsPercentage);
                const fillingStage1 = calculateValue(fillingStage1Percentage);
                const fillingStage2 = calculateValue(fillingStage2Percentage);
                const sc0 = calculateValue(sc0Percentage);
                const sc0Lebih = calculateValue(sc0LebihPercentage);
                const terpetik = calculateValue(terpetikPercentage);
                const dimakanTikus = calculateValue(dimakanTikusPercentage);
                const normalTanaman = calculateValue(normalTanamanPercentage);
                const penyakitPhy = calculateValue(penyakitPhyPercentage);
                const penyakitErw = calculateValue(penyakitErwPercentage);
                const kerdil = calculateValue(kerdilPercentage);

                // Hitung nilai untuk buah alami dan mati (2 kolom terakhir)
                const buahAlami = calculateValue(buahAlamiPercentage);
                const mati = calculateValue(matiPercentage);

                // Hitung populasi per Ha (untuk keperluan lain jika masih diperlukan)
                const populasi = dataEntry.populasi || {};
                const normalPerHa = luasPlot > 0 ? (parseFloat(populasi.normal_p_ba) || 0) / luasPlot : 0;
                const totalPerHa = luasPlot > 0 ? (parseFloat(populasi.total_p_ba) || 0) / luasPlot : 0;
                
                return {
                    plot: plot.plot || plot.plotKey,
                    luasPlot: formatAngkaTotal(plot.luas_plot || '-'), // GUNAKAN formatAngkaTotal untuk luas
                    pjp: formatPJP(plot.pjp || '-'), // GUNAKAN formatPJP untuk PJP
                    
                    // Data fase bunga (diformat dengan pemisah ribuan)
                    openHeart: formatAngkaExcel(openHeart),
                    redBud125: formatAngkaExcel(redBud125),
                    redBud254: formatAngkaExcel(redBud254),
                    earlyCones: formatAngkaExcel(earlyCones),
                    midCones: formatAngkaExcel(midCones),
                    lateCones: formatAngkaExcel(lateCones),
                    earlyPetals: formatAngkaExcel(earlyPetals),
                    midPetals: formatAngkaExcel(midPetals),
                    latePetals: formatAngkaExcel(latePetals),
                    dryPetals: formatAngkaExcel(dryPetals),
                    fillingStage1: formatAngkaExcel(fillingStage1),
                    fillingStage2: formatAngkaExcel(fillingStage2),
                    sc0: formatAngkaExcel(sc0),
                    sc0Lebih: formatAngkaExcel(sc0Lebih),
                    terpetik: formatAngkaExcel(terpetik),
                    dimakanTikus: formatAngkaExcel(dimakanTikus),
                    
                    // Data tanaman (diformat dengan pemisah ribuan)
                    normalTanaman: formatAngkaExcel(normalTanaman),
                    penyakitPhy: formatAngkaExcel(penyakitPhy),
                    penyakitErw: formatAngkaExcel(penyakitErw),
                    kerdil: formatAngkaExcel(kerdil),
                    
                    // Data untuk 2 kolom terakhir (diformat dengan pemisah ribuan)
                    buahAlami: formatAngkaExcel(buahAlami),
                    mati: formatAngkaExcel(mati),
                    
                    // Data populasi per Ha (disimpan untuk keperluan lain)
                    normalPopulasi: parseFloat(populasi.normal_p_ba) || 0,
                    totalPopulasi: parseFloat(populasi.total_p_ba) || 0,
                    normalPerHa: normalPerHa.toFixed(2),
                    totalPerHa: totalPerHa.toFixed(2),
                    
                    // Simpan data mentah untuk perhitungan total
                    rawData: {
                        dataEntry,
                        pjp: parseFloat(plot.pjp) || 1,
                        luas_plot: parseFloat(plot.luas_plot) || 1
                    }
                };
            })
            .sort((a, b) => {
                if (!isNaN(a.plot) && !isNaN(b.plot)) {
                    return parseInt(a.plot) - parseInt(b.plot);
                }
                return a.plot.localeCompare(b.plot);
            });
    };

    const populationData = calculatePopulationPerHa();
    const totalRow = calculateTotalRow(populationData.map(item => item.rawData ? { 
        data_entry: item.rawData.dataEntry, 
        pjp: item.rawData.pjp, 
        luas_plot: item.rawData.luas_plot 
    } : item));

    return (
        <Box>
            <Typography variant="h6" gutterBottom>
                Data Populasi Per HA
            </Typography>
            
            <Card>
                <TableContainer component={Paper} variant="outlined">
                    <Table size="small">
                        <PopulasiPerHaTableHeader/>
                        <TableBody>
                            {populationData.map((item, index) => (
                                <TableRow key={index}>
                                    {/* Plot */}
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                        {item.plot}
                                    </TableCell>
                                    
                                    {/* Luas - GUNAKAN formatAngkaTotal */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>
                                        {item.luasPlot}
                                    </TableCell>
                                    
                                    {/* PJP - GUNAKAN formatPJP */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }}>
                                        {item.pjp}
                                    </TableCell>
                                    
                                    {/* Fase Bunga - Data */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.openHeart}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.redBud125}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.redBud254}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.earlyCones}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.midCones}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.lateCones}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.earlyPetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.midPetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.latePetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.dryPetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.fillingStage1}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.fillingStage2}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.sc0}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.sc0Lebih}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.terpetik}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.dimakanTikus}
                                    </TableCell>
                                    
                                    {/* Tanaman - Data */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.normalTanaman}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.penyakitPhy}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.penyakitErw}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.kerdil}
                                    </TableCell>

                                    {/* 2 KOLOM TERAKHIR: Buah Alami dan Mati */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0' }} align="right">
                                        {item.buahAlami}
                                    </TableCell>
                                    <TableCell align="right">
                                        {item.mati}
                                    </TableCell>
                                </TableRow>
                            ))}
                            
                            {/* BARIS TOTAL */}
                            {totalRow && (
                                <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                    <TableCell sx={{ fontWeight: 'bold', borderRight: '1px solid #e0e0e0' }}>
                                        {totalRow.plot}
                                    </TableCell>
                                    
                                    {/* Luas - Total */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }}>
                                        {totalRow.luasPlot}
                                    </TableCell>
                                    
                                    {/* PJP - Total */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }}>
                                        {totalRow.pjp}
                                    </TableCell>
                                    
                                    {/* Fase Bunga - Total */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.openHeart}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.redBud125}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.redBud254}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.earlyCones}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.midCones}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.lateCones}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.earlyPetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.midPetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.latePetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.dryPetals}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.fillingStage1}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.fillingStage2}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.sc0}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.sc0Lebih}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.terpetik}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.dimakanTikus}
                                    </TableCell>
                                    
                                    {/* Tanaman - Total */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.normalTanaman}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.penyakitPhy}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.penyakitErw}
                                    </TableCell>
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.kerdil}
                                    </TableCell>

                                    {/* 2 KOLOM TERAKHIR: Buah Alami dan Mati - Total */}
                                    <TableCell sx={{ borderRight: '1px solid #e0e0e0', fontWeight: 'bold' }} align="right">
                                        {totalRow.buahAlami}
                                    </TableCell>
                                    <TableCell sx={{ fontWeight: 'bold' }} align="right">
                                        {totalRow.mati}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                
                {populationData.length === 0 && (
                    <Typography color="text.secondary" fontStyle="italic" sx={{ mt: 2 }}>
                        Tidak ada data populasi
                    </Typography>
                )}
            </Card>
        </Box>
    );
};

export default PopulasiPerHaTab;